import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
	TInvoicesRequest,
	TInvoicesResponsePayload,
	TInvoicesStore,
	TFetchPaymentLinkRequestPayload,
	TFetchPaymentLinkResponsePayload,
	TDownloadInvoicePdfRequestPayload,
	TDownloadInvoicePdfResponsePayload,
	TDownloadInvoiceCsvRequestPayload,
	TDownloadInvoiceCsvResponsePayload,
	TLastInvoiceStatusResponse,
} from './types';

export const initialState: TInvoicesStore = {
	invoices: null,
	invoicesLoader: false,
	paymentLink: null,
	paymentLinkLoader: false,
	downloadInvoicePdf: null,
	downloadInvoicePdfLoader: false,
	downloadInvoiceCsv: null,
	downloadInvoiceCsvLoader: false,
	lastInvoiceStatus: null,
	lastInvoiceStatusLoader: false,
};

// ==========================================:

const invoices = createSlice({
	name: '@@invoices',
	initialState,
	reducers: {
		getInvoicesRequest: (state: TInvoicesStore, action: PayloadAction<TInvoicesRequest>) => {
			const invoicesState = state;
			invoicesState.invoices = null;
			invoicesState.invoicesLoader = true;
		},
		getInvoicesSuccess: (
			state: TInvoicesStore,
			action: PayloadAction<TInvoicesResponsePayload>,
		) => {
			const { payload } = action;
			const invoicesState = state;
			invoicesState.invoices = payload;
			invoicesState.invoicesLoader = false;
		},
		getPaymentLinkRequest: (
			state: TInvoicesStore,
			action: PayloadAction<TFetchPaymentLinkRequestPayload>,
		) => {
			const invoicesState = state;
			invoicesState.paymentLink = null;
			invoicesState.paymentLinkLoader = true;
		},
		getPaymentLinkSuccess: (
			state: TInvoicesStore,
			action: PayloadAction<TFetchPaymentLinkResponsePayload>,
		) => {
			const { payload } = action;
			const invoicesState = state;
			invoicesState.paymentLink = payload;
			invoicesState.paymentLinkLoader = false;
		},
		downloadInvoicePdfRequest: (
			state: TInvoicesStore,
			action: PayloadAction<TDownloadInvoicePdfRequestPayload>,
		) => {
			const invoicesState = state;
			invoicesState.downloadInvoicePdf = null;
			invoicesState.downloadInvoicePdfLoader = true;
		},
		downloadInvoicePdfSuccess: (
			state: TInvoicesStore,
			action: PayloadAction<TDownloadInvoicePdfResponsePayload>,
		) => {
			const { payload } = action;
			const invoicesState = state;
			invoicesState.downloadInvoicePdf = payload;
			invoicesState.downloadInvoicePdfLoader = false;
		},
		setDownloadedInvoicePdf: (state: TInvoicesStore) => {
			const invoicesState = state;
			invoicesState.downloadInvoicePdf = null;
		},
		downloadInvoiceCsvRequest: (
			state: TInvoicesStore,
			action: PayloadAction<TDownloadInvoiceCsvRequestPayload>,
		) => {
			const invoicesState = state;
			invoicesState.downloadInvoiceCsv = null;
			invoicesState.downloadInvoiceCsvLoader = true;
		},
		downloadInvoiceCsvSuccess: (
			state: TInvoicesStore,
			action: PayloadAction<TDownloadInvoiceCsvResponsePayload>,
		) => {
			const { payload } = action;
			const invoicesState = state;
			invoicesState.downloadInvoiceCsv = payload;
			invoicesState.downloadInvoiceCsvLoader = false;
		},
		setDownloadedInvoiceCsv: (state: TInvoicesStore) => {
			const invoicesState = state;
			invoicesState.downloadInvoiceCsv = null;
		},
		getLastInvoiceStatusRequest: (state: TInvoicesStore) => {
			const invoicesState = state;
			invoicesState.lastInvoiceStatus = null;
			invoicesState.lastInvoiceStatusLoader = true;
		},
		getLastInvoiceStatusSuccess: (
			state: TInvoicesStore,
			action: PayloadAction<TLastInvoiceStatusResponse>,
		) => {
			const { payload } = action;
			const invoicesState = state;
			invoicesState.lastInvoiceStatus = payload;
			invoicesState.lastInvoiceStatusLoader = false;
		},

		invoiceInitState: () => initialState,
	},
});

export default invoices.reducer;
export const {
	getInvoicesRequest,
	getInvoicesSuccess,
	getPaymentLinkRequest,
	getPaymentLinkSuccess,
	downloadInvoicePdfRequest,
	downloadInvoicePdfSuccess,
	downloadInvoiceCsvRequest,
	downloadInvoiceCsvSuccess,
	setDownloadedInvoicePdf,
	setDownloadedInvoiceCsv,
	getLastInvoiceStatusRequest,
	getLastInvoiceStatusSuccess,
	invoiceInitState,
} = invoices.actions;
